export const HYDRATE_ENGINE_SERIES = "HYDRATE_ENGINE_SERIES";
export const HYDRATE_ENGINE_SERIES_PENDING = "HYDRATE_ENGINE_SERIES_PENDING";
export const HYDRATE_ENGINE_SERIES_FULFILLED = "HYDRATE_ENGINE_SERIES_FULFILLED";
export const HYDRATE_ENGINE_SERIES_REJECTED = "HYDRATE_ENGINE_SERIES_REJECTED";

export const SELECT_ENGINE_SERIES = "SELECT_ENGINE_SERIES";

export const RESET_ENGINE_SERIES = "RESET_ENGINE_SERIES";
